// What is Site Code: https://support.wix.com/en/article/corvid-working-in-the-code-panel
import wixWindow from 'wix-window';


$w.onReady(function () {

if (wixWindow.formFactor === "Mobile") {
        $w("#text36").show()
    }

});